import { observable } from "mobx";
import { Type } from "class-transformer";
import DistributorPaymentRequestStatus from "./distributorPaymentRequestStatus";
import DistributorPaymentRequestType from "./distributorPaymentRequestType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class DistributorIssuedPaymentRequestResponse {
  id!: string;

  @observable
  @Type(() => Date)
  validSinceDate?: Date;

  @observable
  @Type(() => Date)
  validUntilDate!: Date;

  @observable
  @Type(() => Date)
  dueDate!: Date;

  @observable
  @Type(() => Date)
  postingDate?: Date;

  @observable
  variableSymbol!: number;

  @observable
  totalAmount!: number;

  @observable
  paidAmount!: number;

  @observable
  status!: DistributorPaymentRequestStatus;

  @observable
  licensePlatesCount!: number;

  @observable
  type!: DistributorPaymentRequestType;

  @observable
  requestMessage!: string;
}
